module.exports = __webpack_public_path__ + "img/no-avatar.7a21cbe9.svg";